<template>
  <button
    :class="['atom-button', `atom-button--${variant}`]"
    @click="$emit('click')"
  >
    {{ text }}
  </button>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Button",
  props: {
    variant: {
      type: String,
      default: "primary",
      validator: (value) => ["primary", "secondary"].includes(value),
    },
    text: {
      type: String,
      required: true,
    },
  },
  emits: ["click"],
};
</script>

<style scoped>
.atom-button {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  border: none;
  transition: background-color 0.2s ease;
  outline: none;
}

.atom-button--primary {
  background-color: #000;
  color: white;
}

.atom-button--primary:hover {
  background-color: #1d1d1d;
}

.atom-button--secondary {
  background-color: #fff;
  color: #000;
  border: 1px solid #000;
}

.atom-button--secondary:hover {
  background-color: #f9fafb;
}
</style>
